<div class="container-navbar">
    <div class="container-icon" (click)="goToUrl('', false)">
        <div class="container-img"><img src="./assets/navbar/home_icon.svg" alt=""></div>
        <div class="information-container">Resumen</div>
    </div>
    <div class="container-icon">
        <div class="container-img" (click)="goToUrl('stats', false)"><img src="./assets/navbar/stadists.svg" alt="">
        </div>
        <div class="information-container">Estadísticas</div>
    </div>
    <div class="container-icon" (click)="goToUrl('report', false)">
        <div class="container-img"><img src="./assets/navbar/informe_icon.svg" alt=""></div>
        <div class="information-container">Informe</div>
    </div>
    <div class="container-icon" (click)="goToUrl('tips', false)">
        <div class="container-img"><img src="./assets/navbar/tips_icon.svg" alt=""></div>
        <div class="information-container">Consejos</div>
    </div>
    <div class="container-icon" (click)="goToUrl('faqs-client', false)">
        <div class="container-img"><img src="./assets/navbar/faqs.svg" alt=""></div>
        <div class="information-container">FAQs</div>
    </div>
    <div class="container-icon" (click)="goToUrl('home', true)">
        <div class="container-img"><img src="./assets/global-position/header/logout.svg" alt=""></div>
        <div class="information-container">Desconectar</div>
    </div>
</div>